module.exports = __webpack_public_path__ + "img/B38B76_40251D_745042_5F3A30-256px.2707ff33.png";